import { queryOptions, skipToken } from '@tanstack/react-query';

import { fetchPlantName } from './api/plant.api';

export const plantKeys = {
  all: ['plants'] as const,
  names: () => [...plantKeys.all, 'name'] as const,
  name: (plantId: string) => [...plantKeys.names(), plantId] as const,
};

export const plantNameQueryOptions = (plantId: string | null) =>
  queryOptions({
    queryKey: plantKeys.name(plantId ?? ''),
    queryFn: plantId ? ({ signal }) => fetchPlantName(plantId, signal) : skipToken,
    staleTime: Infinity,
    retry: false,
  });
